import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class UserAgentService {
  isMobile(): boolean {
    const userAgent = this.getUserAgent();

    return /android|iPad|iPhone|iPod/i.test(userAgent);
  }

  isDesktop(): boolean {
    return !this.isMobile();
  }

  isProblematicBrowserForYouTube(): boolean {
    return this.isChromeVersion(69, 79);
  }

  isCloverDevices(): boolean {
    return this.isChromeVersion(74);
  }

  /** The isChromeVersion method checks if the user's Chrome browser version matches a specific version or falls within a specified range. It takes two parameters:
   * @param version - required param, the specific Chrome version to check for or the starting point of a version range
   * @param versionRangeEnd -  optional param, if provided, creates a range of versions to check (from version to versionRangeEnd, inclusive)
   */
  private isChromeVersion(version: number, versionRangeEnd: number | null = null): boolean {
    const userAgent = this.getUserAgent();

    if (versionRangeEnd) {
      const versionList = Array.from({ length: versionRangeEnd - version + 1 }, (_, i) => version + i);
      return versionList.some((itemVersion: number) => this.isChromeVersionExact(itemVersion, userAgent));
    }

    return this.isChromeVersionExact(version, userAgent);
  }

  private isChromeVersionExact(version: number, userAgent: string): boolean {
    return userAgent.includes(`Chrome/${version}.`);
  }

  private getUserAgent(): string {
    return navigator.userAgent || navigator.vendor || (window as any).opera;
  }
}
